/*import React from 'react';*/
import { Link } from 'react-router-dom';
import { BookOpen,  } from 'lucide-react';
import {FaInstagram, FaFacebook, FaTwitter, FaLinkedin, FaYoutube} from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center">
              <BookOpen className="h-6 w-6 text-indigo-600" />
              <span className="ml-2 text-lg font-bold text-gray-900">Alfa Entrepreneur</span>
            </div>
            <p className="text-gray-600 text-sm">
              Empowering Start-Ups and running businesses through Successful <br />Businessmen community.
            </p>
            <div className="flex space-x-4">
             
              
            </div>
          </div>


          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Resources
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/Signup" className="text-gray-600 hover:text-indigo-600">
                  Membership
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-indigo-600">
                  Documentation
                </a>
              </li>
              {/* <li>
                <a href="#" className="text-gray-600 hover:text-indigo-600">
                  Guides
                </a>
              </li> */}
              <li>
                <a href="#" className="text-gray-600 hover:text-indigo-600">
                  Help Center
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">
              Legal
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
              <Link to="/Privacy" className="text-gray-600 hover:text-indigo-600">
                  Privacy Policy
                </Link>
              </li>
              {/* <li>
                <a href="#" className="text-gray-600 hover:text-indigo-600">
                  Terms of Service
                </a>
              </li> */}
              <li>
                <a href="#" className="text-gray-600 hover:text-indigo-600">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
          {/* Quick Links */}
          <div className="mt-8 flex justify-center space-x-6">

                <a href="https://www.instagram.com" className="text-gray-600 hover:text-indigo-600" title="Instagram">
                  <FaInstagram size={24} color="gray" />
                </a>
                <a href="https://www.facebook.com/share/1CYCoqLz3k/" className="text-gray-600 hover:text-indigo-600" title="Facebook">
                  <FaFacebook size={24} color="gray" />
                </a>
                <a href="https://www.twitter.com" className="text-gray-600 hover:text-indigo-600" title="Twitter">
                  <FaTwitter size={24} color="gray" />  
                </a>
                <a href="https://www.youtube.com/@filmkaar_rudra" className="text-gray-600 hover:text-indigo-600" title="YouTube">
                  <FaYoutube size={24} color="gray" />
                </a>
                <a href="https://www.linkedin.com" className="text-gray-600 hover:text-indigo-600" title="LinkedIn">
                  <FaLinkedin size={24} color="gray" />
                </a>
            </div>

        </div>


        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-400 text-center">
            © {new Date().getFullYear()} Alfa Entrepreneur. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}